import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroup.Save.IRequest;
type Response = Api.Core.DealerGroup.Save.IResponse;
type Headers = Api.Core.DealerGroup.Save.IHeaders;
const url = '/api/DealerManagement/DealerGroup';
export default async function dealerGroupSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
